import { render, staticRenderFns } from "./LimitedTextarea.vue?vue&type=template&id=21c529d2&"
import script from "./LimitedTextarea.vue?vue&type=script&lang=js&"
export * from "./LimitedTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports